/* eslint-disable react/prop-types */
/* eslint-disable max-lines */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/boolean-prop-naming */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import {
    createRef, lazy, PureComponent, Suspense
} from 'react';

import Html from 'Component/Html';
import { MOBILE_MENU } from 'Component/NavigationTabs/NavigationTabs.config';
import RenderWhenVisible from 'Component/RenderWhenVisible';
import {
    SCROLL_TO_TOP_BUTTON_SHOW_PX
} from 'Component/ScrollToTopButton/ScrollToTopButton.config';
import { SUBSCRIPTION_POPUP, SUBSCRIPTION_POPUP_FOOTER } from 'Component/Subscription/Subscription.config';
import { RENDER_BUSY_POPUP_TIMEOUT, RENDER_POPUP_TIMEOUT } from 'Component/SubscriptionPopup/SubscriptionPopup.config';
import TextPlaceholder from 'Component/TextPlaceholder';
import { BlockListType } from 'Type/CMS.type';
import { DeviceType } from 'Type/Device.type';
import { HistoryType } from 'Type/Router.type';
import CSS from 'Util/CSS';
import history from 'Util/History';
import { handleIosStickyHeader } from 'Util/PromoBanner/PromoBanner';

import { SUBSCRIPTION_POPUP_TIMEOUT, TITLE_OFFSET } from './CmsPage.config';

import './CmsPage.style';
import './CmsPage.style.override';
import './Sitemap.style';
import './affiliate-page.style';

// eslint-disable-next-line max-len
export const SubscriptionPopup = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "subscription" */ 'Component/SubscriptionPopup'));
// eslint-disable-next-line max-len
export const ScrollToTopButton = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "footer" */ 'Component/ScrollToTopButton/ScrollToTopButton.component'));

/** @namespace Scandipwa/Route/CmsPage/Component */
export class CmsPageComponent extends PureComponent {
    static propTypes = {
        page: BlockListType.isRequired,
        // eslint-disable-next-line react/no-unused-prop-types
        siteBaseHasLoaded: PropTypes.bool.isRequired,
        pageIdentifiers: PropTypes.string.isRequired,
        device: DeviceType.isRequired,
        cookieState: PropTypes.bool,
        history: HistoryType.isRequired,
        location: PropTypes.object.isRequired,
        activeOverlay: PropTypes.string
    };

    static defaultProps = {
        cookieState: false,
        activeOverlay: ''
    };

    state = {
        isScrollToTopButtonRender: false,
        popupIsAllowed: false
    };

    cmsPageRef = createRef();

    allowSubscriptionPopup = this.allowSubscriptionPopup.bind(this);

    componentDidMount() {
        const { location: { pathname }, pageIdentifiers } = this.props;
        window.addEventListener('scroll', this.getScrollPosition);
        history.listen(() => this.onRouteChanged());
        handleIosStickyHeader();

        if (pageIdentifiers === 'home') {
            this.setState({ isHomepage: true });
        }

        setTimeout(this.allowSubscriptionPopup, RENDER_POPUP_TIMEOUT);

        if (pathname.match('run-puma-nitro')) {
            CSS.setVariable(
                this.cmsPageRef,
                'cms-min-height',
                '94vh'
            );
        }
    }

    componentDidUpdate() {
        const { cookieState } = this.props;

        const popupTimeout = cookieState ? SUBSCRIPTION_POPUP_TIMEOUT : RENDER_POPUP_TIMEOUT;

        setTimeout(this.allowSubscriptionPopup, popupTimeout);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.getScrollPosition);
    }

    allowSubscriptionPopup() {
        const { activeOverlay } = this.props;

        if (activeOverlay === SUBSCRIPTION_POPUP
            || activeOverlay === SUBSCRIPTION_POPUP_FOOTER
            || activeOverlay === MOBILE_MENU
        ) {
            setTimeout(this.allowSubscriptionPopup, RENDER_BUSY_POPUP_TIMEOUT);

            return;
        }

        this.setState({ popupIsAllowed: true });
    }

    onRouteChanged() {
        const { location: { hash } } = history;

        const anchor = document.getElementById(hash.replace('#', ''));

        if (anchor) {
            window.scrollTo(0, anchor.getBoundingClientRect().top - TITLE_OFFSET + window.scrollY);
        }
    }

    getScrollPosition = () => {
        const scrollPositionY = window.scrollY;
        this.setState({
            isScrollToTopButtonRender: scrollPositionY >= SCROLL_TO_TOP_BUTTON_SHOW_PX
        });
    };

    renderHeading() {
        const { page: { content_heading } } = this.props;

        if (!content_heading) {
            return null;
        }

        return (
            <h1 block="CmsPage" elem="Heading">
                <TextPlaceholder content={ content_heading } />
            </h1>
        );
    }

    renderMagentoContent() {
        const {
            page: { content, content_blocks },
            location: { pathname },
            pageIdentifiers,
            history
        } = this.props;

        if (!content) {
            /** Check if content blocks arrived - render the page as homepage */
            if (
                pageIdentifiers === 'home'
                || pathname.match('run-puma-nitro')
                || (Array.isArray(content_blocks) && content_blocks.length > 0)
            ) {
                return null;
            }

            return (
                <>
                    <div block="CmsPage" elem="SectionPlaceholder" />
                    <div block="CmsPage" elem="SectionPlaceholder" />
                    <div block="CmsPage" elem="SectionPlaceholder" />
                </>
            );
        }

        return <Html content={ content } history={ history } />;
    }

    renderFallback() {
        return <div style={ { height: '500px' } } />;
    }

    renderContentBlock = (block, index) => {
        const { history } = this.props;
        const { isHomepage } = this.state;

        if (isHomepage) {
            if (index === 0) {
                return (
                    <div
                      key={ index }
                      block="kop"
                      elem="wrapped"
                      data-component-position={ index + 1 }
                    >
                        <Html content={ block } history={ history } index={ index } />
                    </div>
                );
            }

            return (
                <RenderWhenVisible fallback={ this.renderFallback } key={ index } index={ index + 1 } isHomepage>
                    <Html content={ block } history={ history } index={ index } />
                </RenderWhenVisible>
            );
        }

        if (index === 0) {
            return (
                <Html key={ index } content={ block } history={ history } index={ index } />
            );
        }

        return (
            <RenderWhenVisible fallback={ this.renderFallback } key={ index }>
                <Html content={ block } history={ history } index={ index } />
            </RenderWhenVisible>
        );
    };

    renderContentBlocks() {
        const {
            page: { content_blocks }
            // pageIdentifiers
        } = this.props;

        if (!content_blocks || !content_blocks.length) {
            return null;
        }

        return content_blocks.map(this.renderContentBlock);
    }

    // Alternate approach of rendering content blocks.
    // Needs a solution for larger screens, will yield ~5point increase to site score
    // renderContentBlocks() {
    //     const {
    //         siteBaseHasLoaded,
    //         page: { content_blocks },
    //         pageIdentifiers,
    //         device
    //     } = this.props;
    //
    //     if (!content_blocks || !content_blocks.length) {
    //         if (pageIdentifiers === 'home') {
    //             return this.renderHomepagePlaceholder();
    //         }
    //
    //         return null;
    //     }
    //
    //     if (device.isMobile) {
    //         return (
    //             <>
    //                 { /* Initially we display only the first block */ }
    //                 <Html key={ 0 } content={ content_blocks[0] } />
    //                 { siteBaseHasLoaded && content_blocks.slice(1).map(this.renderContentBlock) }
    //             </>
    //         );
    //     }
    //
    //     return (
    //         <>
    //             { /* Initially we display only the first few blocks */ }
    //             <Html key={ 0 } content={ content_blocks[0] } />
    //             { content_blocks.length > 1 && <Html key={ 1 } content={ content_blocks[1] } /> }
    //             { /* eslint-disable-next-line max-len */ }
    //             { siteBaseHasLoaded && content_blocks.length > 2 && content_blocks.slice(2).map(this.renderContentBlock) }
    //         </>
    //     );
    // }

    renderHomepagePlaceholder() {
        const { device } = this.props;

        if (device.isMobile) {
            return (
                <div block="CmsPage" elem="HomePagePlaceholderContainer">
                    <div block="CmsPage" elem="HomePagePlaceholder" />
                </div>
            );
        }

        return (
            <div block="CmsPage" elem="HomePagePlaceholderContainer">
                <div block="CmsPage" elem="HomePagePlaceholder" />
                <div block="CmsPage" elem="HomePagePlaceholderCentered">
                    <div block="CmsPage" elem="HomePagePlaceholderSlider" />
                </div>
            </div>
        );

        // To use Router fallback loaded uncomment this
        // return (
        //     <div style={ {
        //         position: 'fixed',
        //         top: '50%',
        //         right: '50%',
        //         display: 'flex',
        //         justifyContent: 'center',
        //         alignItems: 'center',
        //         zIndex: '2'
        //     } }
        //     >
        //         <Loader isLoading />
        //     </div>
        // );
    }

    renderSubscriptionPopup() {
        return (
            <Suspense fallback={ null }>
                <SubscriptionPopup />
            </Suspense>
        );
    }

    render() {
        const {
            page: {
                page_width, title, identifier, disable_margins
            } = {}, baseUrl,
            forceShowSubscriptionPopup
        } = this.props;
        const logoUrl = window.publicPath === undefined ? '/assets/images/global/puma-og-logo.png'
            : `${window.location.origin}${window.publicPath}assets/images/global/puma-og-logo.png`;

        const { isScrollToTopButtonRender, popupIsAllowed } = this.state;

        if (title === 'Affiliate') {
            document.getElementsByTagName('body')[0].classList.add('cms-affiliate');
        } else {
            const bodyClass = document.getElementsByTagName('body')[0].classList;

            if (bodyClass.contains('cms-affiliate')) {
                bodyClass.remove('cms-affiliate');
            }
        }

        if (title === 'Sitemap') {
            return (
                <main
                  block="CmsPage"
                >
                    { isScrollToTopButtonRender && <Suspense fallback={ null }><ScrollToTopButton /></Suspense> }
                    { popupIsAllowed && !forceShowSubscriptionPopup && this.renderSubscriptionPopup() }
                    <div block="CmsPage" elem="Wrapper CmsPage-Sitemap" mods={ { page_width } }>
                        { this.renderHeading() }
                        <div block="CmsPage" elem="Content">
                            { this.renderContentBlocks() }
                            { this.renderMagentoContent() }
                        </div>
                    </div>
                </main>
            );
        }

        if (identifier === 'home') {
            return (
                <main
                  block="CmsPage"
                  itemScope
                  itemType="http://schema.org/Organization"
                >
                    { isScrollToTopButtonRender && <Suspense fallback={ null }><ScrollToTopButton /></Suspense> }
                    { popupIsAllowed && !forceShowSubscriptionPopup && this.renderSubscriptionPopup() }
                    <meta itemProp="url" content={ baseUrl } />
                    <meta itemProp="logo" content={ logoUrl } />
                    <div block="CmsPage" elem="Wrapper" mods={ { page_width, disableMargins: disable_margins } }>
                        { this.renderHeading() }
                        <div block="CmsPage" elem="Content">
                            { this.renderMagentoContent() }
                            { this.renderContentBlocks() }
                        </div>
                    </div>
                </main>
            );
        }

        return (
            <main
              block="CmsPage"
            >
                <div block="CmsPage" elem="Wrapper" mods={ { page_width, disableMargins: disable_margins } }>
                    { this.renderHeading() }
                    <div
                      ref={ this.cmsPageRef }
                      block="CmsPage"
                      elem="Content"
                    >
                        { this.renderContentBlocks() }
                        { this.renderMagentoContent() }
                    </div>
                </div>
            </main>
        );
    }
}

export default CmsPageComponent;
